/* eslint-disable no-underscore-dangle */
// Отправка событий в Яндекс-метрику и другие системы веб-аналитики.

import cookies from "../cookies";
import storage from "../storage";
import ApiRequest from "../api-request";

// Запрашивает и сохраняет информацию о текущих аб-тестах 1 раз в сессию
// Полученное значение сохраняет в localStorage (если не сохранено раньше)
const getABTestParams = async () => {
    const { sessionStorage } = window;
    const currentValues = storage.get("ab_tests") || {};

    if (sessionStorage.getItem("ab_tests_fetched")) return currentValues;

    const api = new ApiRequest("/_/environ/ab", {}, "GET");
    const res = await api.send();

    if (res.tests) {
        sessionStorage.setItem("ab_tests_fetched", 1);
        const testNames = Object.keys(res.tests);

        // если есть сохраненное значение аб-теста - оно перезапишет пришедшее с бэкенда,
        // иначе - установится то, что пришло
        const newValues = testNames.reduce((acc, name) => {
            acc[name] = currentValues[name] || res.tests[name];
            return acc;
        }, {});

        storage.set("ab_tests", newValues);

        return newValues;
    }
};

const Fakes = {
    yaCounter22515688: {

        reachGoal(goalName, params) {
            const paramsStr = JSON.stringify(params);
            console.log(`yaCounter22515688.reachGoal: ${goalName} ${paramsStr}`);
        },

        params(params) {
            const paramsStr = JSON.stringify(params);
            console.log(`yaCounter22515688.params: ${paramsStr}`);
        },

        userParams(params) {
            const paramsStr = JSON.stringify(params);
            console.log(`yaCounter22515688.userParams: ${paramsStr}`);
        },

        getClientID() {
            return 42;
        },

        notBounce() {
            console.log("yaCounter22515688.notBounce");
        },
    },

    ga(method, ...params) {
        const paramsStr = params
            .map(v => JSON.stringify(v))
            .join(", ");

        console.log(`ga.${method}: ${paramsStr}`);
    },

    fbq(method, ...rest) {
        const arg = rest[0];
        console.log(`fbq.${method}: ${arg}`);
    },

    _tmr: {

        push({
            type, id, value, params, goal,
        }) {
            const paramsStr = JSON.stringify(params);
            console.log(`_tmr.push({${type}, ${id}, ${value}, ${goal}, params: ${paramsStr}})`);
        },

    },
};

if (!window.DA.settings.SHOW_ANALYTICS) {
    window.yaCounter22515688 = Fakes.yaCounter22515688;
    window.ga = Fakes.ga;
    window.fbq = Fakes.fbq;
    window._tmr = Fakes._tmr;
}

const Counters = {
    yac: {
        params: {},

        counter() {
            return window.yaCounter22515688 || null;
        },

        reachGoal(goalName, customParams) {
            const counter = this.counter();
            if (!counter) return;

            const params = {
                ...customParams,
                URL: document.location.href,
            };
            counter.reachGoal(goalName, params);
        },

        setParams(params) {
            this.params = {
                ...this.params,
                ...params,
            };
            const counter = this.counter();
            if (counter) {
                counter.params(this.params);
            }
        },

        setUserParams(params) {
            const counter = this.counter();
            if (counter) {
                counter.userParams(params);
            }
        },

        getClientID() {
            const counter = this.counter();
            return counter ? counter.getClientID() : 42;
        },

        notBounce() {
            const counter = this.counter();
            if (!counter) return;

            counter.notBounce();
        },
    },

    goo: {
        params: {},

        counter() {
            return window.ga || null;
        },

        setParams(params) {
            Object.assign(this.params, params);
            const counter = this.counter();
            if (counter) {
                counter("set", this.params);
            }
        },

        reachGoal(goalName, params = {}) {
            const counter = this.counter();
            if (counter) {
                counter("send", "event", goalName, "goal", "", params.order_price || 0);
            }
        },
    },

    vk: {
        counter() {
            return window._tmr || null;
        },

        reachGoal(goalName, params) {
            const counter = this.counter();
            if (!counter) return;

            const value = params.order_price;

            counter.push({
                type: "reachGoal",
                id: 3322155,
                ...(value ? { value } : { params }),
                goal: goalName,
            });
        },
    },
};

const goalSended = goalName => storage.has(goalName);

const Analytics = {
    async init() {
        await this.setParams();
        this.saveMetrikaId();
    },

    reachGoalOnClick(selector, goalName) {
        const elems = document.querySelectorAll(selector);
        const handleClick = () => this.reachGoal(goalName);
        elems.forEach(elem => elem.addEventListener("click", handleClick));
    },

    reachGoal(goalName, params = {}) {
        Counters.yac.reachGoal(goalName, params);
        Counters.goo.reachGoal(goalName, params);
        Counters.vk.reachGoal(goalName, params);
    },

    reachGoalOnce(goalName, postfix, params = {}) {
        const goalStorageName = postfix ? `${goalName}_${postfix}` : goalName;
        if (goalSended(goalStorageName)) {
            return;
        }
        storage.set(goalStorageName, "1");
        this.reachGoal(goalName, params);
    },

    fireNotBounceOnEvent(selector, eventName) {
        const { sessionStorage } = window;
        if (sessionStorage.getItem("notBounced")) return;

        const elems = document.querySelectorAll(selector);
        const handleInput = () => {
            Counters.yac.notBounce();
            sessionStorage.setItem("notBounced", 1);
            elems.forEach(elem => elem.removeEventListener(eventName, handleInput));
        };
        elems.forEach(elem => elem.addEventListener(eventName, handleInput));
    },

    async setParams() {
        const params = await getABTestParams();
        const yacParams = {
            ...params,
            authenticated: window.DA.user.isAuthenticated,
        };
        const gooParams = {
            ...params,
            dimension3: window.DA.user.isAuthenticated,
        };

        Counters.yac.setParams(yacParams);
        Counters.goo.setParams(gooParams);
    },

    saveMetrikaId() {
        if (window.DA.user.isAuthenticated || storage.has("metrika_id")) {
            return;
        }
        const metrikaId = Counters.yac.getClientID();
        Counters.yac.setUserParams({ client_id: metrikaId });
        storage.set("metrika_id", metrikaId);
    },

    saveSignupPoint() {
        cookies.set("signup_point", window.location.pathname);
        storage.set("signup_point", window.location.pathname);
    },
};

export default Analytics;
